export default "__VITE_ASSET__DsIENw4e__"